var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVkBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.687 1.687C0 3.374 0 6.09 0 11.52v.96c0 5.43 0 8.146 1.687 9.833C3.374 24 6.09 24 11.52 24h.96c5.43 0 8.146 0 9.833-1.687C24 20.626 24 17.911 24 12.48v-.96c0-5.43 0-8.146-1.687-9.833C20.626 0 17.911 0 12.48 0h-.96C6.09 0 3.374 0 1.687 1.687zM4.05 7.3c.13 6.24 3.25 9.99 8.72 9.99h.31v-3.57c2.01.2 3.53 1.67 4.14 3.57h2.84c-.78-2.84-2.83-4.41-4.11-5.01 1.28-.74 3.08-2.54 3.51-4.98h-2.58c-.56 1.98-2.22 3.78-3.8 3.95V7.3H10.5v6.92c-1.6-.4-3.62-2.34-3.71-6.92H4.05z",
    fill: "#000"
  })));
}
export default SvgVkBlack;